export const sharedTypes = {
  ADD_COMMENT: "sessions/ADD_COMMENT",
}

export const addComment = (payload) => ({
  type: sharedTypes.ADD_COMMENT,
  payload,
})
